export default "__VITE_ASSET__DO4fMkI2__"